var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericpayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.89 52.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #008600;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.62,
    y: 1.62,
    width: 66.64,
    height: 48.87,
    rx: 4.44,
    ry: 4.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.62,
    y1: 14.95,
    x2: 68.27,
    y2: 14.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.95,
    y1: 28.28,
    x2: 39.39,
    y2: 28.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.95,
    y1: 37.17,
    x2: 30.5,
    y2: 37.17
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericpayment);
export default __webpack_public_path__ + "static/media/generic payment.2bd690876323756bf644dfa087e8f4e8.svg";
export { ForwardRef as ReactComponent };